import { render, staticRenderFns } from "./SalesFlyerLightbox.vue?vue&type=template&id=4824d34f"
import script from "./SalesFlyerLightbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerLightbox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerLightbox.vue?vue&type=style&index=0&id=4824d34f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports